import { z } from 'zod';

/**
 * Roles used across the whole platform.
 * Uppercase matches the Prisma `Role` enum so DB rows and API contracts
 * share one canonical spelling — no conversion layer needed.
 */
export const RoleSchema = z.enum(['CLIENT', 'THERAPIST', 'ADMIN']);
export type Role = z.infer<typeof RoleSchema>;

export const ApiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    details: z.record(z.unknown()).nullable(),
  }),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;
